export enum ArchiveCatalogNameSeqType {
  NONE = 'NONE',
  CHINESE_NUMBER = 'CHINESE_NUMBER',
  ARABIC_NUMBER = 'ARABIC_NUMBER',
  CIRCLED_NUMBER = 'CIRCLED_NUMBER',
  ROMAN_NUMBER = 'ROMAN_NUMBER',
  UPPER_CHINESE_NUMBER = 'UPPER_CHINESE_NUMBER',
}

export const ArchiveCatalogNameSeqTypeMap = {
  [ArchiveCatalogNameSeqType.NONE]: '无',
  [ArchiveCatalogNameSeqType.CHINESE_NUMBER]: '一、二、三...',
  [ArchiveCatalogNameSeqType.ARABIC_NUMBER]: '1、2、3...',
  [ArchiveCatalogNameSeqType.CIRCLED_NUMBER]: '①、②、③...',
  [ArchiveCatalogNameSeqType.ROMAN_NUMBER]: 'Ⅰ、Ⅱ、Ⅲ...',
  [ArchiveCatalogNameSeqType.UPPER_CHINESE_NUMBER]: '壹、贰、叁...',
};

export const ArchiveCatalogNameSeqTypeList = [
  {
    label: ArchiveCatalogNameSeqTypeMap[ArchiveCatalogNameSeqType.NONE],
    value: ArchiveCatalogNameSeqType.NONE,
  },
  {
    label:
      ArchiveCatalogNameSeqTypeMap[ArchiveCatalogNameSeqType.CHINESE_NUMBER],
    value: ArchiveCatalogNameSeqType.CHINESE_NUMBER,
  },
  {
    label:
      ArchiveCatalogNameSeqTypeMap[ArchiveCatalogNameSeqType.ARABIC_NUMBER],
    value: ArchiveCatalogNameSeqType.ARABIC_NUMBER,
  },
  {
    label:
      ArchiveCatalogNameSeqTypeMap[ArchiveCatalogNameSeqType.CIRCLED_NUMBER],
    value: ArchiveCatalogNameSeqType.CIRCLED_NUMBER,
  },
  {
    label: ArchiveCatalogNameSeqTypeMap[ArchiveCatalogNameSeqType.ROMAN_NUMBER],
    value: ArchiveCatalogNameSeqType.ROMAN_NUMBER,
  },
  {
    label:
      ArchiveCatalogNameSeqTypeMap[
        ArchiveCatalogNameSeqType.UPPER_CHINESE_NUMBER
      ],
    value: ArchiveCatalogNameSeqType.UPPER_CHINESE_NUMBER,
  },
];
